import {Component, OnInit, Input} from '@angular/core';
import {Menu} from '../../../../../../shared/services/menu/menu';
import {TranslateService} from '@ngx-translate/core';
import {GenericCrudService} from '../../../../../../shared/services/generic-crud.service';
import {MessageGrowlService} from '../../../../../message/message-growl.service';
import {RequestCachingService} from '../../../../../../shared/services/request-caching.service';
import {Constants} from '../../../../../../constants';
import {Subscription} from 'rxjs/Rx';
import {map} from 'rxjs/operators';
import {File} from '../../../../../../shared/models/file';
import {ChangeDetectorRefHelper} from '../../../../../../shared/helpers/change-detector-ref.helper';
import {forkJoin, Observable, of} from 'rxjs';
import {MessageService} from '../../../../../message/message.service';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-vacation-payment-import-menu-item',
  templateUrl: './vacation-payment-import-menu-item.component.html',
  styleUrls: ['./vacation-payment-import-menu-item.component.scss']
})
export class VacationPaymentImportMenuItemComponent implements OnInit {

  @Input() iconsPath = '';
  @Input() item: Menu;
  @Input() menuPosition = 'left';

  public isDialogVisible = false;

  selectedDate = null;
  protected subscriptions: Subscription[] = [];
  public isDataLoading = false;

  constructor(
    protected translateService: TranslateService,
    protected genericCrudService: GenericCrudService,
    protected messageGrowlService: MessageGrowlService,
    protected messageService: MessageService,
    protected requestCachingService: RequestCachingService
  ) {
  }

  ngOnInit() {
  }

  public onItemClick(item) {
    this.isDialogVisible = true;
    return false;
  }

  public onUpload({files}: { files: File[] }): void {
    this.upload(files).subscribe(() => {

    });
  }

  public upload(files): Observable<any> {
    const observables = [];

    this.isDataLoading = true;
    if (files.length === 0) {
      console.error('No files set for upload!');
      return of(null);
    }

    let i = 0;
    for (const file of files) {
      const fileEntity = {
        name: file.name,
        file: file,
        fileType: file.type,
        fileSize: file.size,
        date: new Date(this.selectedDate).toLocaleDateString()
      }
      observables.push(this.genericCrudService.upload(`intranet/vacationpayments/import?`, fileEntity));
      i++;
    }

    return forkJoin(observables)
      .pipe(
        map(() => {
          this.dialogHide();
          ChangeDetectorRefHelper.detectChanges(this);
        }));
  }

  dialogHide() {
    this.isDialogVisible = false;
    this.isDataLoading = false;
  }
}
